import moment from 'moment';

export const hasError = (error) => {
    const errorMessage = "Erro na API, por favor tente novamente.";

    if (error.data === "Fetch User") {
        return error.message;
    }

    if (!error) {
        console.error(`API ${error.config.url} não encontrada`);
        return errorMessage;
    }
    if (process.env.NODE_ENV === "development") {
        console.error(error.status, error.data.message);
    }
    if (error.data && error.data.message) {
        return error.data.message;
    }

    return errorMessage;
};

export const formatCurrencieValueBRL = (value) => {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
};

export const formatRemovePhoneMask = (value) => {
    return value.toString().replace('(', '').replace(')', '').replace(' ', '').replace('-', '').replace(' ', '');
};

export const formatDocument = (value) => {
    if (!value) return '';
    
    // Remove formatação existente
    const cleanValue = value.replace(/[.\-/]/g, '').toUpperCase();
    
    // CNPJ (14 caracteres) - pode ser alfanumérico a partir de jul/2026
    if (cleanValue.length > 11) {
        const paddedValue = cleanValue.padStart(14, '0');
        // Formato: XX.XXX.XXX/XXXX-XX (suporta letras e números)
        return paddedValue.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
    } else {
        // CPF (11 dígitos) - continua apenas numérico
        const paddedValue = cleanValue.padStart(11, '0');
        return paddedValue.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
}

export const formatData = (value, currentFormat, expectedFormat) => {
    moment.locale('pt-br');
    return moment(value, currentFormat).format(expectedFormat);
};

export const formatCep = (value) => {
    value = value.padStart(8, '0');
    value = value.replace(/^(\d{5})(\d{3})/, '$1-$2');
    return value;
};

export const getNameInitials = (name) => {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

    let initials = [...name.matchAll(rgx)] || [];

    initials = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();

    return initials;
}

/**
 * Converte caractere alfanumérico para valor numérico (para cálculo de dígitos verificadores)
 * Conforme IN RFB nº 2.119/2022: A=10, B=11, ..., Z=35
 */
const charToValue = (char) => {
    const upperChar = char.toUpperCase();
    if (/[0-9]/.test(upperChar)) {
        return parseInt(upperChar, 10);
    }
    // A=10, B=11, ..., Z=35
    return upperChar.charCodeAt(0) - 55;
};

/**
 * Valida CPF (apenas numérico) ou CNPJ (numérico ou alfanumérico)
 * Suporta CNPJ alfanumérico conforme IN RFB nº 2.119/2022
 */
export const validaCpfCnpj = (val) => {
    if (!val) return false;
    
    var v1 = 0;
    var v2 = 0;
    var p;
    var p1;
    var p2;
    var i = 1;
    var aux = false;

    // CPF formatado: 14 caracteres (###.###.###-##)
    if (val.length == 14 && /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(val)) {
        var cpf = val.trim();

        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');

        for (i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
            v1 += cpf[i] * p;
        }

        v1 = ((v1 * 10) % 11);

        if (v1 == 10) {
            v1 = 0;
        }

        if (v1 != cpf[9]) {
            return false;
        }

        for (i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
            v2 += cpf[i] * p;
        }

        v2 = ((v2 * 10) % 11);

        if (v2 == 10) {
            v2 = 0;
        }

        if (v2 != cpf[10]) {
            return false;
        } else {
            return true;
        }
    } 
    // CNPJ formatado: 18 caracteres (XX.XXX.XXX/XXXX-XX) - pode ser alfanumérico
    else if (val.length == 18 && /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/i.test(val)) {
        var cnpj = val.trim().toUpperCase();

        cnpj = cnpj.replace(/\./g, '');
        cnpj = cnpj.replace('-', '');
        cnpj = cnpj.replace('/', '');
        
        // Verifica se todos os caracteres são iguais
        var cnpjArray = cnpj.split('');
        for (i = 1; cnpjArray.length > i; i++) {
            if (cnpjArray[i - 1] != cnpjArray[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        // Verifica se é CNPJ alfanumérico (contém letras)
        const isAlphanumeric = /[A-Z]/i.test(cnpj.substring(0, 12));
        
        if (isAlphanumeric) {
            // Para CNPJ alfanumérico, calcula dígitos verificadores com valores das letras
            // Primeiro dígito verificador
            const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            v1 = 0;
            for (i = 0; i < 12; i++) {
                v1 += charToValue(cnpjArray[i]) * weights1[i];
            }
            v1 = v1 % 11;
            v1 = v1 < 2 ? 0 : 11 - v1;

            if (v1 != parseInt(cnpjArray[12], 10)) {
                return false;
            }

            // Segundo dígito verificador
            const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            v2 = 0;
            for (i = 0; i < 13; i++) {
                v2 += charToValue(cnpjArray[i]) * weights2[i];
            }
            v2 = v2 % 11;
            v2 = v2 < 2 ? 0 : 11 - v2;

            if (v2 != parseInt(cnpjArray[13], 10)) {
                return false;
            }
            
            return true;
        } else {
            // CNPJ numérico tradicional
            for (i = 0, p1 = 5, p2 = 13; (cnpjArray.length - 2) > i; i++, p1--, p2--) {
                if (p1 >= 2) {
                    v1 += cnpjArray[i] * p1;
                } else {
                    v1 += cnpjArray[i] * p2;
                }
            }

            v1 = (v1 % 11);

            if (v1 < 2) {
                v1 = 0;
            } else {
                v1 = (11 - v1);
            }

            if (v1 != cnpjArray[12]) {
                return false;
            }

            for (i = 0, p1 = 6, p2 = 14; (cnpjArray.length - 1) > i; i++, p1--, p2--) {
                if (p1 >= 2) {
                    v2 += cnpjArray[i] * p1;
                } else {
                    v2 += cnpjArray[i] * p2;
                }
            }

            v2 = (v2 % 11);

            if (v2 < 2) {
                v2 = 0;
            } else {
                v2 = (11 - v2);
            }

            if (v2 != cnpjArray[13]) {
                return false;
            } else {
                return true;
            }
        }
    } else {
        return false;
    }
}

export const ActionGetIPAddress = async () => {
    return await fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
            return ip;
        });
}

export const formatFloatToReal = (value) => {
    return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
}


export const getEaster = (year) => {
    const f = Math.floor;
    const G = year % 19;
    const C = f(year / 100);
    const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
    const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
    const day = I - ((year + f(year / 4) + I + 2 - C + f(C / 4)) % 7) + 28;
    const month = day > 31 ? 4 : 3;
    return moment(`${year}-${month}-${day > 31 ? day - 31 : day}`, "YYYY-M-D");
}

// Obter lista de feriados no Brasil para um determinado ano
export const getBrazilianHolidays = (year) => {
    const easter = getEaster(year);

    const holidays = [
        moment(`${year}-01-01`), // Confraternização Universal
        moment(`${year}-04-21`), // Tiradentes
        moment(`${year}-05-01`), // Dia do Trabalhador
        moment(`${year}-09-07`), // Independência
        moment(`${year}-10-12`), // Nossa Senhora Aparecida
        moment(`${year}-11-02`), // Finados
        moment(`${year}-11-15`), // Proclamação da República
        moment(`${year}-12-25`), // Natal
    ];

    holidays.push(easter.clone().subtract(47, "days")); // Carnaval
    holidays.push(easter.clone().subtract(2, "days")); // Sexta-feira Santa
    holidays.push(easter.clone().add(60, "days")); // Corpus Christi

    return holidays.map((date) => date.format("YYYY-MM-DD"));
}

export const isBusinessDay = (date, holidays) => {
    const dayOfWeek = moment(date).day();
    return dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(moment(date).format("YYYY-MM-DD"));
}

export const isValidPhoneNumber = (phone) => {
    const cleaned = phone.replace(/\D/g, '');

    if (/^(\d)\1+$/.test(cleaned)) return false;

    const regex = /^(?:55)?(?:[1-9][0-9])?(?:9\d{8}|[2-8]\d{7})$/;

    return regex.test(cleaned);
}

export const parseBR = (v) => {
    if (typeof v === "number") return v;
    if (!v) return 0;
    return Number(String(v).replace(/\./g, "").replace(",", ".")) || 0;
}

/**
 * Aplica máscara de CPF ou CNPJ (alfanumérico) em tempo real
 * CPF: ###.###.###-## (apenas números)
 * CNPJ: XX.XXX.XXX/XXXX-XX (alfanumérico)
 */
export const maskCpfCnpj = (value) => {
    if (!value) return '';
    
    // Remove tudo exceto letras e números
    let cleaned = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    
    // Limita o tamanho máximo (14 caracteres sem formatação)
    cleaned = cleaned.substring(0, 14);
    
    // Verifica se contém letras (CNPJ alfanumérico)
    const hasLetters = /[A-Z]/.test(cleaned);
    
    if (hasLetters || cleaned.length > 11) {
        // Formato CNPJ: XX.XXX.XXX/XXXX-XX
        let formatted = cleaned;
        if (cleaned.length > 2) {
            formatted = cleaned.substring(0, 2) + '.' + cleaned.substring(2);
        }
        if (cleaned.length > 5) {
            formatted = cleaned.substring(0, 2) + '.' + cleaned.substring(2, 5) + '.' + cleaned.substring(5);
        }
        if (cleaned.length > 8) {
            formatted = cleaned.substring(0, 2) + '.' + cleaned.substring(2, 5) + '.' + cleaned.substring(5, 8) + '/' + cleaned.substring(8);
        }
        if (cleaned.length > 12) {
            formatted = cleaned.substring(0, 2) + '.' + cleaned.substring(2, 5) + '.' + cleaned.substring(5, 8) + '/' + cleaned.substring(8, 12) + '-' + cleaned.substring(12);
        }
        return formatted;
    } else {
        // Formato CPF: ###.###.###-##
        let formatted = cleaned;
        if (cleaned.length > 3) {
            formatted = cleaned.substring(0, 3) + '.' + cleaned.substring(3);
        }
        if (cleaned.length > 6) {
            formatted = cleaned.substring(0, 3) + '.' + cleaned.substring(3, 6) + '.' + cleaned.substring(6);
        }
        if (cleaned.length > 9) {
            formatted = cleaned.substring(0, 3) + '.' + cleaned.substring(3, 6) + '.' + cleaned.substring(6, 9) + '-' + cleaned.substring(9);
        }
        return formatted;
    }
}

/**
 * Verifica se é um CPF ou CNPJ válido (formato básico)
 * Aceita CNPJ alfanumérico conforme IN RFB nº 2.119/2022
 */
export const isValidCpfCnpjFormat = (value) => {
    if (!value) return false;
    
    const cleaned = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    
    // CPF: 11 dígitos numéricos
    if (cleaned.length === 11 && /^\d{11}$/.test(cleaned)) {
        return true;
    }
    
    // CNPJ: 14 caracteres alfanuméricos (últimos 2 são dígitos verificadores)
    if (cleaned.length === 14 && /^[A-Z0-9]{12}\d{2}$/.test(cleaned)) {
        return true;
    }
    
    return false;
}

/**
 * Remove formatação de CPF/CNPJ
 */
export const cleanDocument = (value) => {
    if (!value) return '';
    return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}